<template>
  <el-dialog :title="dialogTilte" :visible.sync="dialogVisible" :close-on-click-modal="false" top="7vh"
             @close="$emit('update:visible',false)">
    <el-form :model="formdata" label-width="96px" :rules="rules" ref="formdata" id="recruitCompany">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="招聘职位:" prop="position">
            <el-input auto-complete="off" placeholder="请输入招聘职位，10个字符内" v-model="formdata.position"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--v-model="editFrom.title"-->
          <el-form-item label="招聘薪资:" prop="salary">
            <el-input auto-complete="off" placeholder="请输入职位薪资，8个字符内" v-model="formdata.salary"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="工作城市:" prop="work_district">
            <v-distpicker :class="{'disabled-select': dialogStatus=='update'}"
                          :province="formdata.work_city" :city="formdata.work_district" @selected="onSelected"
                          hide-area></v-distpicker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="经验要求:" prop="experience">
            <el-select v-model="formdata.experience" placeholder="请选择">
              <el-option
                      v-for="item in experienceOption"
                      :key="item.label"
                      :label="item.label"
                      :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="详细地址:" prop="address">
            <div class="address-list-line">
              <el-input auto-complete="off" v-model="formdata.address"></el-input>
              <span class="address-list-line-span" @click="addressChange">选择地址</span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="联系人:" prop="position">
            <el-input auto-complete="off" placeholder="请输入联系人" v-model="formdata.contact"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人电话:" prop="salary">
            <el-input auto-complete="off" placeholder="请输入联系人电话" v-model="formdata.contact_phone"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="学历要求:" prop="education_background">
            <el-select v-model="formdata.education_background" placeholder="请选择">
              <el-option
                      v-for="item in educationOption"
                      :key="item.label"
                      :label="item.label"
                      :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="招聘结束:" prop="end_time">
            <el-date-picker
                    v-model="formdata.end_time"
                    align="right"
                    type="date"
                    placeholder="选择日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :picker-options="expireTimeOption">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="详情内容" prop="content">
        <div>
          <quill-editor
                  class="quill-editor alleditorHeight"
                  v-model="formdata.content"
                  ref="myQuillEditor"
                  :options="editorOption"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                  @ready="onEditorReady($event)"
          >
            <div id="toolbar" slot="toolbar"> <!-- Add a bold button -->
              <button class="ql-bold" title="加粗">Bold</button>
              <button class="ql-italic" title="斜体">Italic</button>
              <button class="ql-underline" title="下划线">underline</button>
              <button class="ql-strike" title="删除线">strike</button>
              <button class="ql-blockquote" title="引用"></button>
              <button class="ql-code-block" title="代码"></button>
              <button class="ql-header" value="1" title="标题1"></button>
              <button class="ql-header" value="2" title="标题2"></button> <!--Add list -->
              <button class="ql-list" value="ordered" title="有序列表"></button>
              <button class="ql-list" value="bullet" title="无序列表"></button> <!-- Add font size dropdown --> <select
                      class="ql-header" title="段落格式">
                <option selected>段落</option>
                <option value="1">标题1</option>
                <option value="2">标题2</option>
                <option value="3">标题3</option>
                <option value="4">标题4</option>
                <option value="5">标题5</option>
                <option value="6">标题6</option>
              </select> <select class="ql-size" title="字体大小">
                <option value="10px">10px</option>
                <option value="12px">12px</option>
                <option value="14px">14px</option>
                <option value="16px" selected>16px</option>
                <option value="18px">18px</option>
                <option value="20px">20px</option>
              </select>
              <select class="ql-font" title="字体">
                <option value="SimSun">宋体</option>
                <option value="SimHei">黑体</option>
                <option value="Microsoft-YaHei">微软雅黑</option>
                <option value="KaiTi">楷体</option>
                <option value="FangSong">仿宋</option>
                <option value="Arial">Arial</option>
              </select>
              <!-- Add subscript and superscript buttons -->
              <select class="ql-color" value="color" title="字体颜色"></select>
              <select class="ql-background" value="background" title="背景颜色"></select>
              <select class="ql-align" value="align" title="对齐"></select>
              <button class="ql-clean" title="还原"></button>
              <button class="ql-image" title="插入图片"></button>
              <button class="ql-video" title="插入视频"></button>
              <button class="ql-undo" title="撤销" @click="undo"></button>
              <button class="ql-redo" title="重做" @click="redo"></button>
              <!--<button class="ql-clear" title="清空" @click="clearContent"></button>-->
            </div>
          </quill-editor>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" @click="submitForm('formdata')" size="small">{{dialogBtn==0?'确认添加':'确认编辑'}}
        </el-button>
      </el-form-item>
    </el-form>
    <enterpriseAddressDialog :visible.sync="addressdialog" v-if="addressdialog" :formData="editForm"
                             @editFrom="submitCompanyInfo"></enterpriseAddressDialog>
  </el-dialog>
</template>
<script>
  import api from "@/api.js";
  import {quillEditor} from 'vue-quill-editor';
  import Quill from 'quill'; //引入编辑器
  import {ImageDrop} from 'quill-image-drop-module';
  import VDistpicker from 'v-distpicker';
  import enterpriseAddressDialog from "@/components/dialog/enterpriseAddressDialog.vue";
  import { handlers, pasteImage } from "@/assets/js/quill-config";
  import Video from "@/assets/js/quill-video";
  Quill.register(Video, true);
  Quill.register('modules/imageDrop', ImageDrop);

  export default {
    name: "addOrgDialog",
    props: ["visible", "recruitId"],
    components: {
      VDistpicker,
      enterpriseAddressDialog
    },
    watch: {
      visible() {
        this.dialogVisible = this.visible;
      }
    },
    data() {
      return {
        dialogBtn: 0,
        dialogStatus: "",
        addressdialog: false,
        typeDialog: 3, // 1 选择员工 2 选择app管理员 3 招聘选择人员
        userName: '选择联系人',
        editForm:{
          location:'',
          company_address:''
        },
        expireTimeOption: {
          disabledDate(date) {
            return date.getTime() < Date.now();
          }
        },
        experienceOption: [
          {
            value: '1',
            label: '应届毕业生'
          }, {
            value: '2',
            label: '3年及以下'
          }, {
            value: '3',
            label: '3-5年'
          }, {
            value: '4',
            label: '5-10年'
          }, {
            value: '5',
            label: '10年以上'
          }, {
            value: '6',
            label: '不限'
          }],
        educationOption: [
          {
            value: '1',
            label: '大专'
          }, {
            value: '2',
            label: '本科'
          }, {
            value: '3',
            label: '研究生'
          }, {
            value: '4',
            label: '硕士'
          }, {
            value: '5',
            label: '不限'
          }],
        dialogTilte: '',
        editorOption: {
          placeholder: "请输入内容",
          theme: "snow", // or 'bubble'
          history: {
            delay: 2000,
            maxStack: 50,
            userOnly: true
          },
          modules: {
            // imageDrop: true, // 图片推拽上传
            toolbar: {
              container: '#toolbar',
              handlers
            }
          },
          theme: 'snow'
        },
        dialogVisible: this.visible,
        lock: true,
        formdata: {
          position: '',// 招聘职位
          salary: '',// 职位薪资
          work_city: '',// 工作城市
          work_district: '',// 工作市区
          experience: '',// 经验要求
          employee_id: 0,// 联系人（员工id）
          address: '',// 详细地址
          education_background: '',//  学历
          end_time: '',//  招聘结束时间
          content: '',// 招聘详情
          contact: '', //  联系人
          contact_phone: '', //  联系人电话
          location: '' // 经纬度
        },
        rules: {
          position: [
            {required: true, message: '请输入招聘职位', trigger: 'change'}
          ],
          salary: [
            {required: true, message: '请输入职位薪资', trigger: 'change'}
          ],
          work_district: [
            {required: true, message: '请选择工作城市', trigger: 'change'}
          ],
          experience: [
            {required: true, message: '请选择经验要求', trigger: 'change'}
          ],
          // employee_id: [
          //   {required: true, message: '请选择联系人', trigger: 'change'}
          // ],
          contact: [
            {required: true, message: '请填写联系人', trigger: 'change'}
          ],
          contact_phone: [
            {required: true, message: '联系人电话', trigger: 'change'}
          ],
          address: [
            {required: true, message: '请选择详细地址', trigger: 'change'}
          ],
          education_background: [
            {required: true, message: '请选择学历', trigger: 'change'}
          ],
          end_time: [
            {type: 'string', required: true, message: '请选择招聘结束时间', trigger: 'change'}
          ],
          content: [
            {required: true, message: '请填写招聘详情', trigger: 'change'}
          ]
        }
      };
    },
    created() {
      if (this.recruitId) {
        this.dialogTilte = "编辑招聘";
        this.editInfo()
      } else {
        this.dialogTilte = "添加招聘";
      }
    },
    computed: {
      editor() {
        return this.$refs.myQuillEditor.quill;
      },
    },
    mounted() {
      this.$nextTick(function(){
        pasteImage(this.editor)
      })
    },
    methods: {
      undo() {
        this.$refs.myQuillEditor.quill.history.undo();
      },
      redo() {
        this.$refs.myQuillEditor.quill.history.redo();
      },
      // 保存
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.submitsave();
          } else {
            return false;
          }
        });
      },
      editInfo() {
        this.axios
            .post(api.companyadmin_recruitment_detail, {rec_id: this.recruitId})
            .then(response => {
              if (response.data.code == 0) {
                for (let i in this.formdata) {
                  this.formdata[i] = response.data.info[i];
                }
                this.userName = response.data.info.employee_name;
              } else {
              }
            })
            .catch(response => {
            });
      },
      onEditorBlur(option) {
      },
      onEditorFocus(quill) {
        // console.log("editor focus!", quill);
      },
      onEditorReady(quill) {
        let revoke = document.querySelector('.quill-editor .ql-undo') //获取元素
        let redo = document.querySelector('.quill-editor .ql-redo') //获取元素
        let Front = document.createElement('i')  //创建元素
        let Frontredo = document.createElement('i')  //创建元素
        Front.className = "iconfont iconchexiao" //新增class属性
        Frontredo.className = "iconfont iconredo" //新增class属性
        revoke.appendChild(Front) //追加到元素中
        redo.appendChild(Frontredo) //追加到元素中
      },
      // 失去焦点事件
      // 提交保存
      submitsave() {
        let url_ = api.companyadmin_recruitment_add;
        if (this.recruitId) {
          url_ = api.companyadmin_recruitment_edit;
          this.formdata.rec_id = this.recruitId
        }
        this.axios
            .post(url_, this.formdata)
            .then(response => {
              if (response.data.code == 0) {
                this.$emit('userDetail');
                if (!this.recruitId) {
                  this.$message({
                    message: '添加招聘成功',
                  });
                } else {
                  this.$message({
                    message: '编辑招聘成功',
                  });
                }
                this.dialogVisible = false;
              } 
            })
            .catch(response => {
            });
      },
      // 提交编辑保存
      submiteditsave() {
        let params = {
          name: this.formdata.name,
          depart_id: this.departId
        };
        this.axios
            .post(api.department_edit, params)
            .then(response => {
              this.lock = true;
              if (response.data.code == 0) {
                this.$message({
                  message: "修改部门成功",
                });
                this.$emit("addeditdepsucess");
                this.dialogVisible = false;
              } else {
              }
            })
            .catch(response => {
              this.lock = true;
            });
      },
      choose() {
        this.show = !this.show
      },
      onChangeProvince(a) {
      },
      onChangeCity(a) {
      },
      onChangeArea(a) {
        this.show = false
      },
      userDetail(option) {
        this.userName = option.name
        this.formdata.employee_id = option.id
      },
      onSelected(data) {
        this.formdata.work_city = data.province.value;
        this.formdata.work_district = data.city.value;
        // this.$set(this.formdata,'work_district',data.city.value) //这样就能被vue监控到，更新视图
      },
      addressChange(){
        this.editForm.company_address = this.formdata.address;
        this.editForm.location = this.formdata.location;
        this.addressdialog = true
      },
      submitCompanyInfo(option){
        this.formdata.location = option.map.latitude+','+option.map.longitude
        this.formdata.address = option.company_address
        this.addressdialog = false
      }
    }
  };
</script>

